import React, { useEffect, useMemo, useRef, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';


import rolePermissions from '../../../shared/rolePermissions';



import {
  BellIcon,
  MessageIcon,
  MenuIcon,
  UserIcon,
} from '../../../components/ui/AppIcon';


import {
  CloseIcon,
  TargetIcon
} from '../../../components/ui/AppIcon';















const Factory = ( { model, children } ) => {

  const location = useLocation();

  const { logout, user } = useAuth();




  const Service = {

    getDomain: () => {
      const result = {};

      model.modules.domain.forEach( ( item ) => {
        result[ item.slug ] = [];
      } );

      return result;
    },

  };

  const [metadata, setMetadata] = useState( Service.getDomain() );
  
  const [isMetadataLoading, setIsMetadataLoading] = useState(false);
  const [metadataError, setMetadataError] = useState('');


  useEffect(() => {

    let isActive = true;

    const loadMetadata = async () => {

      setIsMetadataLoading(true);
      setMetadataError('');

      try {

        const result = {};

        await Promise.all(
          model.modules.domain.map( async ( item ) => {

            const Factory = require('../../../records/modules').default;

            const response = await Factory({
              slug: item.slug
            }).Meta.getRecords({

            });

            result[ item.slug ] = response.data || [];
          } )
        );

        if (!isActive) {
          return;
        }

        setMetadata(result);
      } catch (error) {
        if (!isActive) {
          return;
        }
        setMetadataError(error?.response?.data?.message || error?.message || 'Unable to load route metadata.');
      } finally {
        if (isActive) {
          setIsMetadataLoading(false);
        }
      }
    };

    loadMetadata();

    return () => {
      isActive = false;
    };
  }, [ model ]);







  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAlertsOpen, setIsAlertsOpen] = useState(false);
  const [isMessagesOpen, setIsMessagesOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const [notificationItems, setNotificationItems] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);
  const [isMarkingAllNotificationsRead, setIsMarkingAllNotificationsRead] = useState(false);
  const [notificationsError, setNotificationsError] = useState('');

  const [messageItems, setMessageItems] = useState([]);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [isMarkingAllMessagesRead, setIsMarkingAllMessagesRead] = useState(false);
  const [messagesError, setMessagesError] = useState('');

  const [undoNotice, setUndoNotice] = useState(null);



  const topbarUserRef = useRef(null);

  const undoTimeoutRef = useRef(null);



  const currentYear = new Date().getFullYear();


  const formatNotificationTime = (value) => {
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return 'Unknown time';
    }
    return parsed.toLocaleString();
  };


























  useEffect(() => {
    setIsSidebarOpen(false);
    setIsAlertsOpen(false);
    setIsMessagesOpen(false);
    setIsUserMenuOpen(false);
  }, [location.pathname]);



  useEffect(() => {

    const pathname = location.pathname;

    const normalized = (!pathname || pathname === '/')? '/' : pathname.replace(/\/+$/, '') || '/';

    const staticEntry = model.auth[normalized.slice(1)];

    if (staticEntry) {
      return staticEntry;
    }


    const user = undefined;

    const links = [];

    (() => {

      if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
        return;
      }

      links.push( {
        path: '/' + model.modules.handle.section,
        label: model.modules.handle.title || '',
      } );
    })();
    
    model.modules.identity.forEach(( item ) => {

      if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
        return;
      }

      links.push( {
        path: '/' + item.section,
        label: item.title || '',
      } );
    });

    model.modules.domain.forEach( ( item ) => {
      metadata[ item.slug ].forEach(( item ) => {

        if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
          return;
        }

        links.push( {
          path: '/' + item.slug,
          label: item.plural || '',
        } );
      });
    });

    ( () => {

      const item = model.auth[ 'settings' ];

      if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
        return;
      }

      links.push( {
        path: '/' + item.section,
        label: item.title || '',
      } );
    } )();

    ( () => {

      const item = model.auth[ 'users' ];

      if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
        return;
      }

      links.push( {
        path: '/' + item.section,
        label: item.title || '',
      } );
    } )();

    const navItem = links.find((item) => normalized === item.path || normalized.startsWith(item.path + '/'));

    document.title = (!navItem ? '' : `${navItem.label} | ` ) + 'ForC';

    return undefined;
  }, [model, location.pathname, metadata]);



  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(max-width: 1080px)');
    const handleChange = (event) => {
      if (!event.matches) {
        setIsSidebarOpen(false);
      }
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);



  useEffect(() => {
    if (!isAlertsOpen) {
      return undefined;
    }

    let isActive = true;
    const loadNotifications = async () => {
      setIsLoadingNotifications(true);
      setNotificationsError('');
      try {

        const Factory = require( '../../../records/auth' );

        const response = await Factory.listMyNotifications({ limit: 8 });
        if (!isActive) {
          return;
        }
        setNotificationItems(response.data || []);
        setUnreadNotifications(response.unreadCount || 0);

      } catch (error) {
        if (!isActive) {
          return;
        }
        const message = error?.response?.data?.message || 'Unable to load notifications right now.';
        setNotificationsError(message);
      } finally {
        if (isActive) {
          setIsLoadingNotifications(false);
        }
      }
    };

    loadNotifications();

    return () => {
      isActive = false;
    };
  }, [isAlertsOpen]);



  useEffect(() => {
    if (!isMessagesOpen) {
      return undefined;
    }

    let isActive = true;
    const loadMessages = async () => {
      setIsLoadingMessages(true);
      setMessagesError('');
      try {

        const Factory = require( '../../../records/auth' );

        const response = await Factory.listMyMessages({ limit: 8 });
        if (!isActive) {
          return;
        }
        setMessageItems(response.data || []);
        setUnreadMessages(response.unreadCount || 0);

      } catch (error) {
        if (!isActive) {
          return;
        }
        const message = error?.response?.data?.message || 'Unable to load messages right now.';
        setMessagesError(message);
      } finally {
        if (isActive) {
          setIsLoadingMessages(false);
        }
      }
    };

    loadMessages();

    return () => {
      isActive = false;
    };
  }, [isMessagesOpen]);





  const toggleNotificationItemState = async (itemId, nextIsUnread) => {
    try {

      const Factory = require( '../../../records/auth' );

      await Factory.updateMyNotificationItemState({ itemId, isUnread: nextIsUnread });

      setNotificationItems((current) => current.map((item) => (
        item.id === itemId ? { ...item, isUnread: nextIsUnread } : item
      )));

      setUnreadNotifications((current) => (nextIsUnread ? current + 1 : Math.max(0, current - 1)));
    } catch (error) {
      const message = error?.response?.data?.message || 'Unable to update notification state.';
      setNotificationsError(message);
    }
  };

  const toggleMessageItemState = async (itemId, nextIsUnread) => {
    try {

      const Factory = require( '../../../records/auth' );

      await Factory.updateMyMessageItemState({ itemId, isUnread: nextIsUnread });
      
      setMessageItems((current) => current.map((item) => (
        item.id === itemId ? { ...item, isUnread: nextIsUnread } : item
      )));
      
      setUnreadMessages((current) => (nextIsUnread ? current + 1 : Math.max(0, current - 1)));
    } catch (error) {
      const message = error?.response?.data?.message || 'Unable to update message state.';
      setMessagesError(message);
    }
  };

  const markAllNotificationsRead = async () => {
    const unreadIds = notificationItems.filter((item) => item.isUnread).map((item) => item.id);
    setIsMarkingAllNotificationsRead(true);
    setNotificationsError('');
    try {

      const Factory = require( '../../../records/auth' );

      await Factory.markMyNotificationsSeen();

      setUnreadNotifications(0);
      setNotificationItems((current) => current.map((item) => ({ ...item, isUnread: false })));
      if (unreadIds.length > 0) {
        if (undoTimeoutRef.current) {
          clearTimeout(undoTimeoutRef.current);
        }
        setUndoNotice({
          feedKind: 'notifications',
          itemIds: unreadIds,
          message: 'Notifications marked as read.',
        });
        undoTimeoutRef.current = setTimeout(() => {
          setUndoNotice(null);
          undoTimeoutRef.current = null;
        }, 6000);
      }
    } catch (error) {
      const message = error?.response?.data?.message || 'Unable to mark all notifications as read.';
      setNotificationsError(message);
    } finally {
      setIsMarkingAllNotificationsRead(false);
    }
  };

  const markAllMessagesRead = async () => {
    const unreadIds = messageItems.filter((item) => item.isUnread).map((item) => item.id);
    setIsMarkingAllMessagesRead(true);
    setMessagesError('');
    try {

      const Factory = require( '../../../records/auth' );

      await Factory.markMyMessagesSeen();

      setUnreadMessages(0);
      setMessageItems((current) => current.map((item) => ({ ...item, isUnread: false })));
      if (unreadIds.length > 0) {
        if (undoTimeoutRef.current) {
          clearTimeout(undoTimeoutRef.current);
        }
        setUndoNotice({
          feedKind: 'messages',
          itemIds: unreadIds,
          message: 'Messages marked as read.',
        });
        undoTimeoutRef.current = setTimeout(() => {
          setUndoNotice(null);
          undoTimeoutRef.current = null;
        }, 6000);
      }
    } catch (error) {
      const message = error?.response?.data?.message || 'Unable to mark all messages as read.';
      setMessagesError(message);
    } finally {
      setIsMarkingAllMessagesRead(false);
    }
  };

  const dismissUndoNotice = () => {
    if (undoTimeoutRef.current) {
      clearTimeout(undoTimeoutRef.current);
      undoTimeoutRef.current = null;
    }
    setUndoNotice(null);
  };

  const undoMarkAllRead = async () => {
    if (!undoNotice) {
      return;
    }

    const itemIds = undoNotice.itemIds;
    const itemIdSet = new Set(itemIds);
    if (undoNotice.feedKind === 'notifications') {
      try {

        const Factory = require( '../../../records/auth' );

        await Promise.all(
          itemIds.map((itemId) => Factory.updateMyNotificationItemState({ itemId, isUnread: true }))
        );

        let restoredCount = 0;

        setNotificationItems((current) => current.map((item) => {
          if (!itemIdSet.has(item.id) || item.isUnread) {
            return item;
          }
          restoredCount += 1;
          return { ...item, isUnread: true };
        }));
        setUnreadNotifications((current) => current + restoredCount);
        dismissUndoNotice();
      } catch (error) {
        const message = error?.response?.data?.message || 'Unable to restore notifications unread state.';
        setNotificationsError(message);
      }
      return;
    }

    try {

      const Factory = require( '../../../records/auth' );

      await Promise.all(
        itemIds.map((itemId) => Factory.updateMyMessageItemState({ itemId, isUnread: true }))
      );

      let restoredCount = 0;

      setMessageItems((current) => current.map((item) => {
        if (!itemIdSet.has(item.id) || item.isUnread) {
          return item;
        }
        restoredCount += 1;
        return { ...item, isUnread: true };
      }));

      setUnreadMessages((current) => current + restoredCount);
      dismissUndoNotice();
    } catch (error) {
      const message = error?.response?.data?.message || 'Unable to restore messages unread state.';
      setMessagesError(message);
    }
  };




  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(max-width: 1080px)');
    const shouldLockScroll = mediaQuery.matches && isSidebarOpen;
    document.body.style.overflow = shouldLockScroll ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [isSidebarOpen]);



  useEffect(() => {
    function handlePointerDown(event) {
      if (!topbarUserRef.current || topbarUserRef.current.contains(event.target)) {
        return;
      }
      setIsAlertsOpen(false);
      setIsMessagesOpen(false);
      setIsUserMenuOpen(false);
    }

    function handleKeyDown(event) {
      if (event.key !== 'Escape') {
        return;
      }
      setIsAlertsOpen(false);
      setIsMessagesOpen(false);
      setIsUserMenuOpen(false);
    }

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);



  useEffect(() => (
    () => {
      if (undoTimeoutRef.current) {
        clearTimeout(undoTimeoutRef.current);
      }
    }
  ), []);























  const Sections = [

    {
      
      Button: () => {

        const unreadNotificationsBadge = ((count) => {
          if (!Number.isFinite(count) || count <= 0) {
            return null;
          }
          return count > 99 ? '99+' : String(count);
        })(unreadNotifications);

        return (
          <button
            aria-expanded={isAlertsOpen}
            aria-haspopup="menu"
            aria-label={unreadNotificationsBadge ? `Open alerts, ${unreadNotificationsBadge} unread` : 'Open alerts'}
            className="icon-button topbar-menu-trigger"
            onClick={() => {
              setIsAlertsOpen((current) => !current);
              setIsMessagesOpen(false);
              setIsUserMenuOpen(false);
            }}
            type="button"
          >
            {unreadNotificationsBadge ? (
              <span className="count-badge count-badge-compact count-badge-success count-badge-overlay">
                {unreadNotificationsBadge}
              </span>
            ) : null}
            <BellIcon />
          </button>
        );
      },
      
      Component: () => {

        if ( !isAlertsOpen ) return null;

        return (
          <section className="topbar-popover topbar-user-popover" role="menu">
            <div className="topbar-popover-header">
              <strong>Alerts</strong>
              <div className="topbar-popover-header-actions">
                <span>{unreadNotifications} unread</span>
                <button
                  className="topbar-mark-all-button"
                  disabled={unreadNotifications === 0 || isMarkingAllNotificationsRead}
                  onClick={markAllNotificationsRead}
                  type="button"
                >
                  {isMarkingAllNotificationsRead ? 'Updating...' : 'Mark all as read'}
                </button>
              </div>
            </div>
            {isLoadingNotifications ? (
              <p className="topbar-popover-empty">Loading alerts...</p>
            ) : null}
            {!isLoadingNotifications && notificationsError ? (
              <p className="topbar-popover-error">{notificationsError}</p>
            ) : null}
            {!isLoadingNotifications && !notificationsError && notificationItems.length === 0 ? (
              <p className="topbar-popover-empty">No new alerts right now.</p>
            ) : null}
            {!isLoadingNotifications && !notificationsError && notificationItems.length > 0 ? (
              <ul className="topbar-feed-list">
                {notificationItems.map((item) => (
                  <li className="topbar-feed-item" key={item.id}>
                    <div className="topbar-feed-item-card">
                      <NavLink className="topbar-feed-link" onClick={() => setIsAlertsOpen(false)} to={item.path}>
                        <span className="topbar-feed-row">
                          <span className="topbar-feed-title">{item.title}</span>
                          {item.isUnread ? (
                            <span className="count-badge count-badge-dot count-badge-success" title="Unread">
                              <span className="sr-only">Unread</span>
                            </span>
                          ) : null}
                        </span>
                        <span className="topbar-feed-time">{formatNotificationTime(item.updatedAt)}</span>
                      </NavLink>
                      <button
                        className="topbar-feed-action"
                        onClick={() => toggleNotificationItemState(item.id, !item.isUnread)}
                        type="button"
                      >
                        Mark {item.isUnread ? 'read' : 'unread'}
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            ) : null}
          </section>
        );
      }

    },

    {
      
      Button: () => {

        const unreadMessagesBadge = ((count) => {
          if (!Number.isFinite(count) || count <= 0) {
            return null;
          }
          return count > 99 ? '99+' : String(count);
        })(unreadMessages);

        return (
          <button
            aria-expanded={isMessagesOpen}
            aria-haspopup="menu"
            aria-label={unreadMessagesBadge ? `Open messages, ${unreadMessagesBadge} unread` : 'Open messages'}
            className="icon-button topbar-menu-trigger"
            onClick={() => {
              setIsMessagesOpen((current) => !current);
              setIsAlertsOpen(false);
              setIsUserMenuOpen(false);
            }}
            type="button"
          >
            {unreadMessagesBadge ? (
              <span className="count-badge count-badge-compact count-badge-info count-badge-overlay">
                {unreadMessagesBadge}
              </span>
            ) : null}
            <MessageIcon />
          </button>
        );
      },
      
      Component: () => {

        if ( !isMessagesOpen ) return null;

        return (
          <section className="topbar-popover topbar-user-popover" role="menu">

            <div className="topbar-popover-header">
              <strong>Messages</strong>
              <div className="topbar-popover-header-actions">
                <span>{unreadMessages} unread</span>
                <button
                  className="topbar-mark-all-button"
                  disabled={unreadMessages === 0 || isMarkingAllMessagesRead}
                  onClick={markAllMessagesRead}
                  type="button"
                >
                  {isMarkingAllMessagesRead ? 'Updating...' : 'Mark all as read'}
                </button>
              </div>
            </div>

            {isLoadingMessages ? (
              <p className="topbar-popover-empty">Loading messages...</p>
            ) : null}

            {!isLoadingMessages && messagesError ? (
              <p className="topbar-popover-error">{messagesError}</p>
            ) : null}

            {!isLoadingMessages && !messagesError && messageItems.length === 0 ? (
              <p className="topbar-popover-empty">No new messages right now.</p>
            ) : null}

            {!isLoadingMessages && !messagesError && messageItems.length > 0 ? (
              <ul className="topbar-feed-list">
                {messageItems.map((item) => (
                  <li className="topbar-feed-item" key={item.id}>
                    <div className="topbar-feed-item-card">
                      <NavLink className="topbar-feed-link" onClick={() => setIsMessagesOpen(false)} to={item.path}>
                        <span className="topbar-feed-row">
                          <span className="topbar-feed-title">{item.title}</span>
                          {item.isUnread ? (
                            <span className="count-badge count-badge-dot count-badge-info" title="Unread">
                              <span className="sr-only">Unread</span>
                            </span>
                          ) : null}
                        </span>
                        <span className="topbar-message-body">{item.body}</span>
                        <span className="topbar-feed-time">{formatNotificationTime(item.updatedAt)}</span>
                      </NavLink>
                      <button
                        className="topbar-feed-action"
                        onClick={() => toggleMessageItemState(item.id, !item.isUnread)}
                        type="button"
                      >
                        Mark {item.isUnread ? 'read' : 'unread'}
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            ) : null}

          </section>
        );
      }

    },

    {
      
      Button: () => {
        return (
          <button
            aria-expanded={isUserMenuOpen}
            aria-haspopup="menu"
            className="topbar-profile-trigger"
            onClick={() => {
              setIsUserMenuOpen((current) => !current);
              setIsAlertsOpen(false);
              setIsMessagesOpen(false);
            }}
            type="button"
          >
            <span className="avatar-pill">
              <UserIcon className="nav-icon" />
            </span>
            <div className="topbar-profile-copy">
              <strong>{user?.fullName || user?.email || 'User'}</strong>
              <p>{user?.roleLabel || rolePermissions.getRoleLabel(user?.role) || 'member'}</p>
            </div>
          </button>
        );
      },
      
      Component: () => {

        if ( !isUserMenuOpen ) return null;

        return (
          <section className="topbar-popover topbar-user-popover" role="menu">
            {require( '../../../apps/data/identity/auth' ).default( model.auth, rolePermissions, user, setIsUserMenuOpen, logout )}
            {require( '../../../apps/data/domain/auth' ).default( model.auth, rolePermissions, user, setIsUserMenuOpen )}
          </section>
        );
      }

    },

  ];













  return (
    <div className="app-frame">

      <header className="topbar">

        <div className="topbar-main">
          <button
            aria-controls="app-sidebar"
            aria-expanded={isSidebarOpen}
            aria-label="Open navigation"
            className="icon-button sidebar-toggle"
            onClick={() => setIsSidebarOpen(true)}
            type="button"
          >
            <MenuIcon />
          </button>
          <div className="brand-lockup">
            <img alt="ForC" className="brand-mark" src={`${process.env.PUBLIC_URL}/forC-Logo.svg`} />
            <div className="topbar-brand-copy">
              <span className="topbar-brand-kicker">Organization OS</span>
              <span className="topbar-brand-title">Enterprise</span>
            </div>
          </div>
        </div>

        <div className="topbar-user" ref={topbarUserRef}>

          {Sections.map(( Section ) => {
            return (
              <div className="topbar-menu-shell">
                <Section.Button />
                <Section.Component />
              </div>
            );
          })}

        </div>

      </header>


      <div className={`app-shell${isSidebarOpen ? ' is-sidebar-open' : ''}`}>

        <button
          aria-hidden={!isSidebarOpen}
          aria-label="Close navigation"
          className="sidebar-backdrop"
          onClick={() => setIsSidebarOpen(false)}
          tabIndex={isSidebarOpen ? 0 : -1}
          type="button"
        />
        <aside className={`sidebar${isSidebarOpen ? ' is-open' : ''}`} id="app-sidebar">

          <div className="sidebar-header">
            <button
              aria-label="Close navigation"
              className="icon-button sidebar-close"
              onClick={() => setIsSidebarOpen(false)}
              type="button"
            >
              <CloseIcon />
            </button>
          </div>

          <div className="workspace-chip">
            <TargetIcon className="nav-icon" />
            <span>Strategy Workspace</span>
          </div>

          <nav className="sidebar-nav">

            {require( '../../../apps/data/identity/modules' ).default( model.modules, rolePermissions, user, setIsSidebarOpen, metadata )}
            {require( '../../../apps/data/domain/modules' ).default( model.modules, rolePermissions, user, setIsSidebarOpen, metadata )}

          </nav>

        </aside>


        <main className="main-content">

          {undoNotice ? (
            <div className="topbar-undo-toast" role="status">
              <span>{undoNotice.message}</span>
              <div className="topbar-undo-toast-actions">
                <button className="topbar-undo-button" onClick={undoMarkAllRead} type="button">
                  Undo
                </button>
                <button className="topbar-undo-dismiss" onClick={dismissUndoNotice} type="button">
                  Dismiss
                </button>
              </div>
            </div>
          ) : null}

          <nav aria-label="Breadcrumb" className="breadcrumbs">
            <ol className="breadcrumbs-list">
              <li className="breadcrumbs-item" key={'/'}>
                <Link className="breadcrumbs-link" to={''}>
                  {'Home'}
                </Link>
                <span className="breadcrumbs-separator" aria-hidden="true">/</span>
              </li>
              {(() => {

                const breadcrumbs = (() => {

                  const pathname = location.pathname;

                  const normalized = (!pathname || pathname === '/')? '/' : pathname.replace(/\/+$/, '') || '/';

                  const segments = normalized.split('/').filter(Boolean);

                  if (segments.length === 0) {
                    return [];
                  }

                  const staticEntry = model.auth[segments[0]];

                  if (staticEntry && segments.length === 1) {
                    return [
                      {
                        label: staticEntry.label,
                        to: staticEntry.path
                      }
                    ];
                  }



                  const user = undefined;

                  const links = [];

                  (() => {

                    if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
                      return;
                    }

                    links.push( {
                      path: '/' + model.modules.handle.section,
                      label: model.modules.handle.title,
                    } );
                  })();
                  
                  model.modules.identity.forEach(( item ) => {

                    if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
                      return;
                    }

                    links.push( {
                      path: '/' + item.section,
                      label: item.title,
                    } );
                  });

                  model.modules.domain.forEach( ( item ) => {
                    metadata[ item.slug ].forEach(( item ) => {

                      if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
                        return;
                      }

                      links.push( {
                        path: '/' + item.slug,
                        label: item.plural,
                      } );
                    });
                  });

                  ( () => {

                    const item = model.auth[ 'settings' ];

                    if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
                      return;
                    }

                    links.push( {
                      path: '/' + item.section,
                      label: item.title,
                    } );
                  } )();

                  ( () => {

                    const item = model.auth[ 'users' ];

                    if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
                      return;
                    }

                    links.push( {
                      path: '/' + item.section,
                      label: item.title,
                    } );
                  } )();

                  const navItem = links.find((item) => normalized === item.path || normalized.startsWith(item.path + '/'));
                  

                  if (!navItem) {
                    return staticEntry ? [
                      {
                        label: staticEntry.label,
                        to: staticEntry.path
                      }
                    ] : [];
                  }

                  const result = [
                    {
                      label: navItem.label,
                      to: navItem.path
                    }
                  ];

                  const tail = segments.slice(1);

                  if (tail.length === 0) {
                    return result;
                  }

                  if (tail[0] === 'new') {
                    result.push({ label: 'New' });
                    return result;
                  }

                  if (tail[0] === 'edit') {
                    result.push({ label: 'Edit' });
                    return result;
                  }

                  result.push({ label: 'Details' });

                  if (tail[1] === 'edit') {
                    result.push({ label: 'Edit' });
                  }

                  return result;
                })();
                
                return breadcrumbs.map((crumb, index) => {
                  const isCurrent = index === breadcrumbs.length - 1;
                  return (
                    <li className="breadcrumbs-item" key={crumb.to || crumb.label}>
                      {crumb.to && !isCurrent ? (
                        <Link className="breadcrumbs-link" to={crumb.to}>
                          {crumb.label}
                        </Link>
                      ) : (
                        <span className="breadcrumbs-current" aria-current={isCurrent ? 'page' : undefined}>
                          {crumb.label}
                        </span>
                      )}
                      {!isCurrent ? <span className="breadcrumbs-separator" aria-hidden="true">/</span> : null}
                    </li>
                  );
                })
              })()}
            </ol>
          </nav>

          <section className="page-body">
            {children}
          </section>

        </main>

      </div>

      <footer className="app-footer">
        <span>© {currentYear} ForC</span>
        <span className="app-footer-tagline">Strategic planning, execution, and insight in one place.</span>
      </footer>

    </div>
  );
};

export default Factory;
